module.exports = __webpack_public_path__ + "../assets/img/ApploiBoosted.7f4b6002c0f61e4756c56fa8cccf5587.png";